<script>
/**
     * @overview 文件素材选择组件
     *
     * @author huojinzhao
     */

import mapUtils, { $http, $token } from "@/utils";
import PreviewAnimation from "../AppQiniu/components/PreviewAnimation.vue";
import PreviewAudio from "../AppQiniu/components/PreviewAudio.vue";
import PreviewImage from "../AppQiniu/components/PreviewImage.vue";
import PreviewVideo from "../AppQiniu/components/PreviewVideo.vue";
import FileBox from "./FileBox.vue";

export default {
  name: "FileDialog",

  components: {
    PreviewAnimation,
    PreviewAudio,
    PreviewImage,
    PreviewVideo,
    FileBox,
  },

  props: {
    // 是否是zip格式路径输出
    isZip: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "https://upload.qiniup.com/",
    },
    bucket: {
      type: String,
      default: "https://oa-statics.caihonggou.com",
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    // 是否上传中
    loading: false,

    targetInputID: null,

    fileTypes: {
      image: "png,jpg,jpeg",
      audio: "mp3,wav",
      video: "mp4,webm",
      rar: "zip",
      animation: "zip",
      doc: "doc, docx",
      pdf: "pdf",
    },
  }),

  computed: {
    previewType() {
      const suffix = this.type
        .slice(1)
        .padStart(this.type.length, this.type[0].toUpperCase());
      let compName = `Preview${suffix}`;
      if (['PreviewPdf', 'PreviewDoc'].includes(compName)) {
        compName = 'PreviewAnimation';
      }
      return compName;
    },

    fileName() {
      return this.value.split("/").pop();
    },

    fileDownload() {
      return `${this.value}`;
    },
  },

  mounted() {
    this.targetInputID = this.$refs.appFile.inputID;
  },

  methods: {
    ...mapUtils("form", ["errorAlert"]),

    beforeUpload(url) {
      this.$emit("input", url);
      this.$emit("success", { url });
    },

    resourceClear() {
      this.$emit("input", "");
      this.$emit("delete", { url: this.value });
    },
    cancel() {
      this.innerVisible = false;
    },
    resourcePreview() {
      this.$refs.content.preview();
    },
  },
};
</script>

<template>
  <FileBox
    v-loading="loading"
    ref="appFile"
    v-bind="$attrs"
    :type="type"
    :is-zip="isZip"
    class="app-qiniu"
    @success="beforeUpload"
    @error="$form_errorAlert"
  >
    <AppCard
      v-if="value && preview"
      slot="placeholder"
      class="layout-mask-master app-qiniu__preview"
      width="100%"
      height="100%"
      radius
    >
      <component
        ref="content"
        :is="previewType"
        :src="previewUrl || value"
        class="app-qiniu__content"
      />

      <slot name="preview-footer" />

      <template slot="mask" >
        <AppIcon
          :for="targetInputID"
          element="label"
          type="edit"
        />
        <AppIcon
          type="preview"
          @click.prevent="resourcePreview"
        />
        <AppIcon
          type="delete"
          @click.prevent="resourceClear"
        />
      </template>
    </AppCard>
    <slot
      v-else
      slot="placeholder"
      name="placeholder"
    />
  </FileBox>
</template>

<style lang="postcss">
    .app-qiniu {
        position: relative;
    }

    .app-qiniu:hover {
        border-color: var(--color-primary);
    }

    .app-qiniu__preview {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        border: 2px dashed var(--bd-color-default);;
    }

    .app-qiniu__preview:hover {
        border-width: 2px;
    }

    .app-qiniu__content {
    //flex-grow: 1;
        display: block;
        height: 160px;
    }

    .app-qiniu .layout-mask-attendant > .iconfont {
        margin: 0px 10px;
    }

</style>
